/**
 * REWE Digital GmbH.
 * IT-Verticals
 * zr-variant-switch-item component
 */

@use '../zr-css-icon/zr-css-icon.scss' as i;

// component name
$component: 'zr-variant-list-item';

:host {
    color: var(--ci-neutral800);
}

.#{$component}__inner-container {
    display: flex;
    width: calc(100% - 24px);
}



.#{$component}__inner-container [type="radio"]:checked + label {
    background-color: var(--ci-primary100);
    border: 1px solid var(--ci-primary400);

    .#{$component}__radio--inner {
        background-color: var(--ci-primary100);
        color: var(--ci-primary400);

        &--notAvailable {
            background-color: var(--ci-neutral200);
            color: var(--ci-neutral400);
        }
    }
}

.zr-variant-list-item__inner-container [type="radio"]:checked + .zr-variant-list-item__label--notAvailable {
    background-color: var(--ci-neutral200);
    color: #6c6c6c;
}

.#{$component}__radio {
    width: 20px;
    height: 20px;
}

.#{$component}__radio--inner {
    color: white;

    &--notAvailable {
        color: white;
    }
}

.#{$component}__input{
    position: fixed;
    opacity: 0;
    width: 0;
}

.#{$component}__input[type="radio"]:focus-visible + label {
    outline: 2px solid #00434F;
    outline-offset: -2px;

    &--notAvailable {
        outline: 2px solid var(--ci-neutral400);
    }
}


.#{$component}__label {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 1.5px;
    width: 100%;
    line-height: 1.2em;
    min-height: 50px;
    border: 1px solid var(--ci-neutral400);
    border-radius: 6px;
    padding: 4px 10px 4px 5px;
    cursor: pointer;



    &:hover {
        background-color: var(--ci-neutral200);
    }
}

.#{$component}__header {
    display: flex;
    flex: 1;
    margin-left: 4px;

    span {
        flex: 1;
        align-content: center;
        padding-top: 2px;
        font-weight: 700;
    }
}

.#{$component}__icon {
    @include i.get-icon-only(badge);
    padding-right: 8px;
}

.#{$component}__price {
    font-size: 16px;
    font-weight: 700;
    text-align: right;
}

.#{$component}__per-unit {
    font-size: 12px
}

